import { render, staticRenderFns } from "./adminDataDelete.vue?vue&type=template&id=dc1e9afc&"
import script from "./adminDataDelete.vue?vue&type=script&lang=js&"
export * from "./adminDataDelete.vue?vue&type=script&lang=js&"
import style0 from "./adminDataDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports